import React from 'react';
import { Navigate } from 'react-router-dom';
import MarketingPage from '../pages/MarketingPage';

/**
 * SmartMarketing - Affiche la page marketing UNIQUEMENT sur heartbeats.fr
 * 
 * LOGIQUE SÉCURISÉE :
 * - heartbeats.fr → MarketingPage (page de vente SaaS Heartbeats)
 * - TOUT LE RESTE → Redirection vers "/" (protège les sites clients)
 * 
 * Cette page de vente est destinée aux commerçants intéressés par la plateforme.
 * Elle ne doit JAMAIS apparaître sur les sites des clients (ex: la-petite-epicerie.shop)
 */
const SmartMarketing = () => {
  const hostname = window.location.hostname.toLowerCase();
  
  // UNIQUEMENT si c'est EXACTEMENT heartbeats.fr ou www.heartbeats.fr
  // (PAS les previews Emergent qui peuvent contenir "heartbeats" dans l'URL)
  if (hostname === 'heartbeats.fr' || hostname === 'www.heartbeats.fr') {
    return <MarketingPage />;
  }
  
  // TOUT LE RESTE (la-petite-epicerie.shop, localhost, preview Emergent, etc.)
  // → Redirection vers la page d'accueil (SÉCURISÉ pour les clients)
  return <Navigate to="/" replace />;
};

export default SmartMarketing;
